import React, { Fragment } from 'react';
import { Select } from '@nackle/paper';
const {
  Option
} = Select;
export default function Options(options = [], includeAll = false) {
  return /*#__PURE__*/React.createElement(Fragment, null, includeAll && /*#__PURE__*/React.createElement(Option, {
    value: ""
  }, "All"), options.filter(option => {
    return option.label !== null;
  }).map(option => {
    if (typeof option === 'object') {
      return /*#__PURE__*/React.createElement(Option, {
        key: option.value,
        value: option.value
      }, option.label);
    } else {
      return /*#__PURE__*/React.createElement(Option, {
        key: option,
        value: option
      }, option);
    }
  }));
}
export const filterOptions = (input, option) => {
  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
//# sourceMappingURL=options.js.map